module.exports = __webpack_public_path__ + "media/Sphere_12.0817f9e6.mp4";